var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-4 d-flex justify-content-between align-items-center" },
    [
      _c("h3", { staticClass: "m-0 pe-2" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }